import styled from "styled-components";
import React, {useEffect, useState} from "react";
import {isTouchDevice} from "../../playerUtils";
import {AnimatePresence, motion} from "framer-motion";

const SnoMobile = `
    #n-song-image {
        max-width: 70%;
        margin: 70px 0;
        
    }
    
    #n-song-artist, #n-song-title {
        display: none;
    }
`;


const SnoMedia = styled.div`
    height: 100dvh;
    position: absolute;
    width: 100dvw;
    overflow: hidden;
    justify-content: center;
    align-items: center;
    display: ${props => props.show ? "flex" : "none"};
    opacity: ${props => props.fade};
    transition: 0.5s opacity;
    
    font-family: inherit !important; // Форсируем наследование
  
    * {
      font-family: inherit !important;
      font-synthesis: none; // Предотвращаем синтез шрифтов
    }
    
    
    .n-center {
        display: flex;
        flex-direction: column;
        align-content: center;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        color: white;
        height: 100dvh;
    }
    
    #n-song-artist, .n-song-progress-container {
        margin-top: 10px;
    }
    
    .n-song-progress-container {
        margin-top: 13px;
        width: 400px;
        opacity: 0;
    }
    
    #n-song-progress-line {
        width: 400px;
        
    }
    
    #n-song-image {
        width: 600px;
        border-radius: 15px;
    }
    
    #n-song-progress-pointer {
         width: 0%;
    }
    
    #n-song-artist {
        font-size: 24px;
        font-weight: 500;
        margin-bottom: 4px;
        margin-top: 25px;
    }
    
    #n-song-title {
        font-size: 20px;
        opacity: 0.5;
        font-weight: 300;
    }
    
    ${props => props.isMobile ? SnoMobile : ""}
`;


const SRichContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: stretch;
    flex-direction: row;
    flex-wrap: nowrap;
    width: 100%;
    margin-top: -50px;
    
    > .rn-right {
        display: flex;
        flex-direction: column;
        white-space: nowrap;
        width: 50%;
        margin-right: 50px;
        justify-content: center;
        height: 600px;
    }
    
    > .rn-left {
        width: 43%;
        display: flex;
        flex-direction: row;
        justify-content: center;
    }
    
    > .rn-right #n-song-artist {
        font-size: 86px;
        margin: 0;
        margin-top: -5px;
        line-height: 85px;
        white-space: normal;
    }
    
    > .rn-right #n-song-title {
        font-size: 56px;
        margin: 0;
        margin-top: 25px;
        white-space: normal;
    }
    
    > .rn-left #n-song-image {
        border-radius: 10px;
    }
`;

export function NoMediaScreen({trackInfo, hasRich, setLyricsAllowed, isMobile=isTouchDevice()}) {
    const [fade, setFade] = useState(0);
    const [show, setShow] = useState(false);

    const [title, setTitle] = useState(null);
    const [artist, setArtist] = useState("Загрузка...");
    const [cover, setCover] = useState("");
    const [animating, setIsAnimating] = useState(false);
    const [pendingShow, setPendingShow] = useState(false);

    useEffect(() => {
        if (cover !== trackInfo.cover || title !== trackInfo.title || artist !== trackInfo.artist) {
            setTitle(trackInfo.title);
            setArtist(trackInfo.artist || "Загрузка...");
            setCover(trackInfo.cover);
            if (show) {
                setLyricsAllowed(false);
                setIsAnimating(true);
                console.log("animating: true");
                setTimeout(() => {
                    setIsAnimating(false);
                    console.log("animating: false");
                    setPendingShow(prev => {
                        console.log("check prev:", prev);
                        setShow(prev);
                        return prev;
                    })
                }, 600);
                setTimeout(() => {
                    setLyricsAllowed(true);
                }, 800);
            }
        }
    }, [trackInfo]);

    useEffect(() => {
        if (isMobile) {
            if (hasRich) {
                setFade(0);
                setTimeout(() => {
                    setShow(false);
                }, 500);
            } else {
                setFade(1);
                setTimeout(() => {
                    setShow(true);
                }, 500);
            }
        } else {
            if (show && (animating || cover !== trackInfo.cover || title !== trackInfo.title || artist !== trackInfo.artist)) {
                console.log("pending:", !hasRich);
                setPendingShow(!hasRich);
            } else {
                console.log("set show:", !hasRich);
                setShow(!hasRich);
                setPendingShow(!hasRich);
            }
        }

    }, [hasRich]);

    return <SnoMedia show={isMobile ? show : true} fade={isMobile ? fade : 1} isMobile={isMobile}>
        {isMobile && <div className="n-center">
            <img id="n-song-image" src={trackInfo.cover || ""} />
            <span id="n-song-artist">{trackInfo.title || "Загрузка..."}</span>
            <span id="n-song-title">{trackInfo.artist}</span>
            <div className="n-song-progress-container">
                <div id="n-song-progress-line">
                    <div id="n-song-progress-pointer"></div>
                </div>
            </div>
        </div>}
        {!isMobile && (
            <AnimatePresence>
                {show && <SRichContainer>
                    <motion.div class="rn-left"  initial={{x: "-10dvw", opacity: 0}} animate={{x: "0dvw", opacity: 1}} exit={{x: "-10dvw", opacity: 0}} transition={{duration: 0.3, ease: "easeInOut"}}>
                        <AnimatePresence mode="popLayout">
                            <motion.img key={cover}
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        exit={{ opacity: 0 }}
                                        transition={{ duration: 0.4 }} id="n-song-image" src={cover} />
                        </AnimatePresence>
                    </motion.div>
                    <motion.div class="rn-right" initial={{x: "10vw", opacity: 0}} animate={{x: "0dvw", opacity: 1}} exit={{x: "10dvw", opacity: 0}} transition={{duration: 0.3, ease: "easeInOut"}}>
                        <AnimatePresence mode="wait">
                            <motion.span key={title}
                                         id="n-song-artist"
                                         initial={{ opacity: 0, y: "40px" }}
                                         animate={{ opacity: 1, y: "0px" }}
                                         exit={{ opacity: 0, y: "-40px" }}
                                         transition={{ duration: 0.2 }}
                                         style={{
                                             fontFamily: 'inherit',
                                             willChange: 'opacity',
                                             backfaceVisibility: 'hidden',
                                         }}
                            >
                                {title}
                            </motion.span>
                        </AnimatePresence>

                        <AnimatePresence mode="wait">
                            <motion.span id="n-song-title"
                                         initial={{ opacity: 0, y: "40px" }}
                                         animate={{ opacity: 0.5, y: "0px" }}
                                         exit={{ opacity: 0, y: "-40px" }}
                                         transition={{ duration: 0.2 }}
                                         key={artist}
                                         style={{
                                             fontFamily: 'inherit',
                                             willChange: 'opacity',
                                             backfaceVisibility: 'hidden',
                                         }}
                            >
                                {artist}
                            </motion.span>
                        </AnimatePresence>
                    </motion.div>
                    <div className="n-song-progress-container" style={{display: "none"}}>
                        <div id="n-song-progress-line">
                            <div id="n-song-progress-pointer"></div>
                        </div>
                    </div>
                </SRichContainer>}
            </AnimatePresence>
        )}
    </SnoMedia>
}
